import React from "react";
import Loader from "../../Loader";
import PageContent from "./PageContent";

const ComingSoon = () => {
	return (
		<>
			<Loader />
			<PageContent />
		</>
	);
};
export default ComingSoon;
